export default __webpack_public_path__ + "static/media/RhymesCountAlong_12.9cbe0487.png";